// @ts-nocheck

import React, { useCallback } from 'react';
import styled from 'styled-components';

import useRouter from '../../../../hooks/useRouter';
import { __ } from '../../../../i18n/l10n';
import GridsPublicFiltersContainer from '../../containers/public/GridsPublicFiltersContainer';
import { getPoolPathFromPublic } from '../../utils/routes';

import { Bloc, Span, ArrowPrevious } from './common';

const Nav = styled.nav`
  overflow: hidden;
  ${({ theme }) => theme.grids.desktopBloc}
`;
type Props = {
  className?: string;
};

const GridsPublicMenuDesktop = ({ className }: Props) => {
  const { history, location } = useRouter();

  const goBack = useCallback(() => {
    history.push(getPoolPathFromPublic(location.pathname));
  }, [history, location.pathname]);

  return (
    <>
      <Bloc onClick={goBack}>
        <ArrowPrevious />
        <Span>{__('Back to grid creation')}</Span>
      </Bloc>
      <Nav className={className}>
        <GridsPublicFiltersContainer />
      </Nav>
    </>
  );
};

export default GridsPublicMenuDesktop;
